<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ valid }" tag="form">
      <div class="p-box">
        <div class="p-box__body">
          <Info>{{ $t('messages.qualityCheckDescription') }}</Info>
          <Loading v-if="loading" />
          <div v-else class="urlForm">
            <div class="p-formGrid">
              <div class="p-formGrid__items">
                <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                  <label class="c-formLabel">
                    {{ attribute.displayName }}
                  </label>
                  <ValidationProvider v-slot="{ errors, value, handleChange }" key="url_validation" v-model="url" :name="'url'" rules="url">
                    <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                    <ValidationError :error="errors[0]" />
                  </ValidationProvider>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div class="p-box__footer">
          <div class="buttonGroup">
            <KkButton
              color="secondary"
              :text="$t('labels.cancel')"
              class="buttonGroup__item"
              :to="{ name: 'CompaniesLocationStore', params: { company_uuid: currentCompanyUuid, store_uuid: currentStoreUuid } }"
            />
            <KkButton
              color="primary"
              :text="$t('labels.submitFilterCond')"
              :disabled="!valid"
              class="buttonGroup__item"
              @click.prevent="handleSubmit"
            />
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Info from '../../../../../components/Info'
import { google } from '../../../../../modules/sitesConst'
import ValidationError from '../../../../../components/ValidationError'
import Loading from '../../../../../components/Loading'
import { KkButton } from '../../../../../components/base'

export default {
  name: 'CompaniesLocationStoreAttributesUrlEdit',
  components: {
    Info,
    ValidationError,
    Loading,
    KkButton
  },
  emits: ['update-title', 'update-breadcrumbs'],
  data() {
    return {
      url: ''
    }
  },
  computed: {
    ...mapState({
      store: state => state.companiesLocationStore.data,
      attributes: state => state.companiesStoreGmbAttributes.attributes,
      loading: state => state.companiesStoreGmbAttributes.loading,
    }),
    ...mapGetters({
      urlGroupDataFlattenList: 'companiesStoreGmbAttributes/urlGroupDataFlattenList',
    }),
    google: () => google,
    attributeId() {
      return this.$route.params.attribute_id
    },
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentStoreUuid() {
      return this.$route.params.store_uuid
    },
    /**
     * @return { groupData }
     */
    attribute() {
      return this.urlGroupDataFlattenList.find(v => v.parent === this.attributeId)
    }
  },
  async created() {
    await Promise.all([
      this.readStore({ company_uuid: this.currentCompanyUuid, store_uuid: this.currentStoreUuid }),
      this.readGmbAttributes()
    ])
    if (this.attribute.uriValues && this.attribute.uriValues.length) {
      this.url = this.attribute.uriValues[0].uri
    }
    this.$emit(
      'update-title',
      this.$t('pages.CompaniesLocationStoreAttributesUrlEdit.title', { name: this.store.attributes.name, url: this.attribute?.displayName })
    )
    const breadcrumbs = [
      {
        name: this.$t('pages.CompaniesDashboards.title'),
        pathName: 'CompaniesDashboards',
        query: {},
      },
      {
        name: this.$t('pages.CompaniesLocationStores.title'),
        pathName: 'CompaniesLocationStores',
        query: {},
      },
      {
        name: this.$t('pages.CompaniesLocationStore.basicTitle'),
        pathName: 'CompaniesLocationStore',
        query: {},
      },
    ]
    breadcrumbs.push({
      name: this.$t('pages.CompaniesLocationStoreAttributesUrlEdit.titleForBreadcrumb', { url: this.attribute?.displayName })
    })
    this.$emit('update-breadcrumbs', breadcrumbs)
  },
  methods: {
    ...mapActions({
      readStore: 'companiesLocationStore/readStore',
      readGmbAttributes: 'companiesStoreGmbAttributes/readGmbAttributes',
      changeAttribute: 'companiesStoreGmbAttributes/reduceAttribute',
      updateGmbAttribute: 'companiesStoreGmbAttributes/updateGmbAttribute'
    }),
    async handleSubmit() {
      const result = await this.$refs.form.validate()
      if (!result) return
      const uriValues = []
      if (this.url !== '') {
        uriValues.push({
          uri: this.url
        })
      }
      await this.changeAttribute({
        type: this.attribute.valueType,
        payload: {
          uriValues: uriValues,
          metadata: this.attribute
        }
      })
      this.updateGmbAttribute(this.attributes)
    }
  }
}
</script>

<style lang="scss" scoped>
.urlForm {
  padding: 28px 32px 0;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
}
.buttonGroup {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  &__item {
    flex-grow: 0;
  }
}
</style>
